import type { CSSProperties } from 'vue'
import type { ExtendedBlock } from 'widget-components/integrations/CustomPage/types'
import { getStickyPositionStyle } from 'widget-components/components/Container/container-sticky-position'
import { isNotNil } from 'ramda'

export const getBlockClasses = (block: ExtendedBlock): string[] => {
    if (block.type === 'CONTAINER') {
        return [
            'h-full',
            block.responsiveVisibility && block.responsiveVisibility !== 'always'
                ? `${block.responsiveVisibility}-visible`
                : undefined,
        ].filter(isNotNil)
    }

    return []
}

export const getBlockStyles = (block: ExtendedBlock): CSSProperties => {
    if (block.type === 'CONTAINER') {
        return {
            ...(block.flexMultiplier !== undefined ? ({ flex: block.flexMultiplier }) : ({})),
            ...getStickyPositionStyle(block.stickyPosition),
        }
    }

    return {}
}
